import React, { useState } from 'react'
import AccountManagementWeb from '../components/AccountManagementWeb/AccountManagementWeb'

const PageAccountManagementWeb = () => {
  return <AccountManagementWeb />
}

export default PageAccountManagementWeb
